/** PURE_IMPORTS_START .._.._Observable,.._.._operator_race PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { race } from '../../operator/race';
Observable.prototype.race = race;
//# sourceMappingURL=race.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/race.js
// module id = 549
// module chunks = 0